// A trip can be marked complete only from its start date (the API answers 409 TRIP_NOT_STARTED before that).
export const TRIP_NOT_STARTED_MESSAGE = "You can mark this trip complete once it has started.";

// A trip made from a RoamMyWay booking carries its booking reference.
export const isBookedTrip = (trip) => Boolean(trip?.bookingRef);

export const hasTripStarted = (trip, now = new Date()) => {
  if (!trip?.startDate) return false;
  const start = new Date(trip.startDate).setHours(0, 0, 0, 0);
  return start <= new Date(now).setHours(0, 0, 0, 0);
};
